import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

// cercloud 838 add to translation.languages: 'en_US', 'pt_PT', 'fi_FI', 'sk_SK','cs_CZ'

const store = new Vuex.Store({
  state: {
    currentComponent: 'entry-component',
    isBlue: true,
    notConnectNow: true,
    measUnitFile: '',
    translation: {
      languages: ['cs_CZ', 'da_DK', 'de_DE', 'nl_NL', 'en_GB', 'en_US', 'ee_EE', 'fi_FI', 'fr_FR', 'it_IT', 'lv_LV', 'lt_LT', 'no_NO', 'pt_PT', 'pl_PL', 'ru_RU', 'sk_SK', 'es_ES', 'sv_SE'],
      langFile: ''
    }
  },
  getters: {
    currentComponent: state => state.currentComponent,
    isBlue: state => state.isBlue,
    notConnectNow: state => state.notConnectNow,
    languages: state => state.translation.languages,
    countries: state => state.translation.countries,
    langFile: state => state.translation.langFile,
    measUnitFile: state => state.measUnitFile
  },
  mutations: {
    changeName(state, newName) {
      state.currentComponent = newName
    },
    changeColor(state, color) {
      state.isBlue = color
    },
    changeConnectNow(state, notConnectNow) {
      state.notConnectNow = notConnectNow
    },
    setLangFile(state, file) {
      state.translation.langFile = file
    },
    setMeasUnitFile(state, unit) {
      state.measUnitFile = unit
    }
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store.js